import type { SVGProps } from 'react'

export function Calculator2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M17.3333 2H6.22222C4.99492 2 4 2.99492 4 4.22222V19.7778C4 21.0051 4.99492 22 6.22222 22H17.3333C18.5606 22 19.5556 21.0051 19.5556 19.7778V4.22222C19.5556 2.99492 18.5606 2 17.3333 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.82716 14.6543C8.09989 14.6543 8.32099 14.4332 8.32099 14.1605C8.32099 13.8878 8.09989 13.6667 7.82716 13.6667C7.55443 13.6667 7.33333 13.8878 7.33333 14.1605C7.33333 14.4332 7.55443 14.6543 7.82716 14.6543Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.7778 14.6543C12.0505 14.6543 12.2716 14.4332 12.2716 14.1605C12.2716 13.8878 12.0505 13.6667 11.7778 13.6667C11.505 13.6667 11.2839 13.8878 11.2839 14.1605C11.2839 14.4332 11.505 14.6543 11.7778 14.6543Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.7284 14.6543C16.0011 14.6543 16.2222 14.4332 16.2222 14.1605C16.2222 13.8878 16.0011 13.6667 15.7284 13.6667C15.4557 13.6667 15.2346 13.8878 15.2346 14.1605C15.2346 14.4332 15.4557 14.6543 15.7284 14.6543Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.7284 18.6049C16.0011 18.6049 16.2222 18.3838 16.2222 18.1111C16.2222 17.8384 16.0011 17.6173 15.7284 17.6173C15.4557 17.6173 15.2346 17.8384 15.2346 18.1111C15.2346 18.3838 15.4557 18.6049 15.7284 18.6049Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.7778 18.6049C12.0505 18.6049 12.2716 18.3838 12.2716 18.1111C12.2716 17.8384 12.0505 17.6173 11.7778 17.6173C11.505 17.6173 11.2839 17.8384 11.2839 18.1111C11.2839 18.3838 11.505 18.6049 11.7778 18.6049Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.82716 18.6049C8.09989 18.6049 8.32099 18.3838 8.32099 18.1111C8.32099 17.8384 8.09989 17.6173 7.82716 17.6173C7.55443 17.6173 7.33333 17.8384 7.33333 18.1111C7.33333 18.3838 7.55443 18.6049 7.82716 18.6049Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.33333 5.33333H16.2222V9.77778H7.33333V5.33333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
